module.exports = __webpack_public_path__ + "static/media/apple.1d80a496.png";